import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { AppearDirective } from '../../../../../../directive/appear.directive';
import { RouterLink } from '@angular/router';

interface miniVideo {
  id: string;
  name: string;
}
@Component({
  selector: 'app-step-three',
  templateUrl: './step3.component.html',
  styleUrls: ['./step3.component.scss'],
  standalone: true,
  imports: [AppearDirective, NgClass, RouterLink],
})
export class Step3Component {
  anim: boolean = false;
  miniVideos: {
    top: miniVideo[];
    bottom: miniVideo[];
  } = {
    top: [
      { id: '276334', name: '2ynk63' },
      { id: '264619', name: '7uq8yb' },
      { id: '242712', name: 'aftk9s' },
      { id: '288087', name: 'gyhaw5' },
      { id: '256458', name: 'pmrdzx' },
      { id: '223712', name: 'pycubf' },
    ],
    bottom: [
      { id: '233394', name: 'qas6mh' },
      { id: '261574', name: 'qu8nsb' },
      { id: '290808', name: 'rgjy75' },
      { id: '244196', name: 'swczj8' },
      { id: '261564', name: 'ugbew8' },
      { id: '252743', name: 'zq45pt' },
    ],
  };

  hoverMiniVideo({ target }: { target: HTMLVideoElement }): void {
    const svg: HTMLElement = target.parentNode.firstChild as HTMLElement;
    svg.classList.toggle('hide');

    if (target.paused) {
      target.muted = true;
      target.play();
      return;
    }

    target.pause();
  }
}
